import { forwardRef } from 'react';

import PropTypes from 'prop-types';

import CloseIcon from '@mui/icons-material/Close';
import Slide from '@zenbusiness/zui/Slide';
import WistiaPlayer from '@zenbusiness/zui/WistiaPlayer';

import * as Styled from './WebinarDialog.style';

const SlideUpTransition = forwardRef((props, ref) => <Slide ref={ref} direction="up" {...props} />);

function WebinarDialog({ title, videoId, onClose }) {
  return (
    <Styled.Root fullScreen open TransitionComponent={SlideUpTransition}>
      <Styled.Content>
        <Styled.Header>
          <Styled.TitleWrapper>
            <Styled.Title>{title}</Styled.Title>
          </Styled.TitleWrapper>
          <Styled.CloseButton icon={<CloseIcon />} label="Close" onClick={onClose} />
        </Styled.Header>
        <Styled.Body>
          <WistiaPlayer videoId={videoId} clickstreamProps={{ videoName: title }} />
        </Styled.Body>
      </Styled.Content>
    </Styled.Root>
  );
}

WebinarDialog.propTypes = {
  title: PropTypes.string.isRequired,
  videoId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default WebinarDialog;
